/* eslint-disable */
import {lista, nao_autorizado, pegaDados, processar} from '../../services/GenericAPI'
import {Filtro} from "../../models/filtro/filtro";
import {Caixa} from '../../models/caixa'
import {CaixaSCH, getCaixaSCH, getMovCaixaSCH} from "../../search/CaixaSCH";
import {MovimentoCaixa} from "../../models/movimento_caixa";

const url = '/caixas'

const state = {
  all: [],
  allList: [],
  caixa: new Caixa(),
  mov_caixa: new MovimentoCaixa(),
  filtro: new Filtro()
}

const getters = {
  listaAllCaixas: (state) => {
    return state.allList
  },

  listaCaixas: (state) => {
    return state.all
  },
  pegaCaixa: (state) => {
    return state.caixa
  },
  pegarMovCaixa: (state) => {
    return state.mov_caixa
  },
  pegaFiltro: (state) => {
    return state.filtro
  }
}

const actions = {
  searchItem({commit}, search) {
    state.filtro.filters.search = [];
    state.filtro.filters.addSearch(['data','contas.descricao'], '%' + search + '%', 'ilike')
  },
  async getItem({commit}, {id, onSucesso,onErro}) {
    try {
      var filtro = getCaixaSCH('caixa_id', id, '=')
      const list = (await pegaDados(url+'/get', filtro)).data
      if (list.data[0] !== undefined) {
        commit('SET_CAIXA', list.data[0])
        onSucesso(list.data[0])
      } else {
        onErro()
      }
    } catch (error) {
      onErro()
      console.log(error)
    }
  },
  async getItemMov({commit}, {id, onSucesso,onErro}) {
    try {
      var filtro = getMovCaixaSCH('movimento_caixa_id', id, '=')
      const list = (await pegaDados(url+'/get_mov', filtro)).data
      if (list.data[0] !== undefined) {
        commit('SET_MOV_CAIXA', list.data[0])
        onSucesso(list.data[0])
      } else {
        onErro()
      }
    } catch (error) {
      onErro()
      console.log(error)
    }
  },

  setFiltro({commit}, perPage) {
    commit('SET_FILTRO', CaixaSCH(perPage))
  },



  async setAllListCaixas({commit},{onSucesso, onErro}) {
    try {
      const list = (await lista(url + '/all')).data
      commit('SET_ALL_LIST', list)
      onSucesso()
    } catch (error) {
      console.log(error)
      onErro()
    }
},
  async setAllCaixas({commit},{onSucesso, onErro}) {
    try {
      const list = (await pegaDados(url + '/get', state.filtro)).data
      commit('SET_CAIXAS', list)
      onSucesso()
    } catch (error) {
      console.log(error)
      onErro()
      nao_autorizado(error)
    }
  },
  async processarCaixa({commit}, {acao,onSucesso,onErro}) {
    try {
      let res = await processar(url + (acao === 'gravar' ? '/commit' : '/delete'), state.caixa, acao)

      this.dispatch('geral/setMsgSuccess', res.data.message)
      onSucesso()
    } catch (error) {
      onErro()
      console.log('error: ',error)
      this.dispatch('geral/setObjMsgError', error.response.data)
    }
  },
  async processarMovCaixa({commit}, {acao,onSucesso,onErro}) {
    try {
      let res = await processar(url + (acao === 'gravar' ? '/commit_mov' : '/delete_mov'), state.mov_caixa, acao)

      this.dispatch('geral/setMsgSuccess', res.data.message)
      onSucesso()
    } catch (error) {
      onErro()
      console.log('error: ',error)
      this.dispatch('geral/setObjMsgError', error.response.data)
    }
  },
  async processarFecharCaixa({commit}, {caixa,onSucesso,onErro}) {
    try {
      let res = await processar(url + '/fechar_caixa', caixa, 'gravar')

      this.dispatch('geral/setMsgSuccess', res.data.message)
      onSucesso()
    } catch (error) {
      onErro()
      console.log('error: ',error)
      this.dispatch('geral/setObjMsgError', error.response.data)
    }
  },
  setCaixa({commit}, caixa) {
    commit('SET_CAIXA', caixa)
  },
  setMovCaixa({commit}, mov) {
    commit('SET_MOV_CAIXA', mov)
  },
}

const mutations = {

  SET_ALL_LIST(state, filtro) {
    state.allList = filtro
  },
  SET_FILTRO(state, filtro) {
    state.filtro = filtro
  },
  SET_CAIXAS(state, caixas) {
    state.all = caixas
  },
  SET_CAIXA(state, caixa) {
    state.caixa = caixa
  },
  SET_MOV_CAIXA(state, mov_caixa) {
    state.mov_caixa = mov_caixa
  },

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
